import type { TagType } from "@/types/entities/tags";

export const MAX_FILE_SIZE_MB = 1;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const buildFormValues = (tag?: TagType) =>
  tag
    ? {
        name: tag.name,
        description: tag.description || "",
        active: tag.active,
        image: undefined as File | undefined,
      }
    : {
        name: "",
        description: "",
        active: false,
        image: undefined as File | undefined,
      };

export interface NewTagModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  editData?: TagType;
}
